import React, { useState, useEffect } from 'react';
import './OrderCheck.css';
import { getApiUrl } from '../config/api';

function OrderCheck() {
    const [orderName, setOrderName] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState([]);

    const query = async (event) => {
        event.preventDefault();
        setLoading(true);
        console.log('查詢開始');
        try {
            const apiUrl = getApiUrl('/orders/get_orders');
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ order_name: orderName })
            });
            console.log('收到回應');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setLoading(false);
            if (data.length === 0) {
                console.log('未找到相關數據');
                setResult([]);
            } else {
                console.log('查詢成功，資料如下：', data);
                setResult(data);
            }
        } catch (error) {
            console.log('查詢失敗，錯誤信息：', error);
            setLoading(false);
            setResult([]);
        }
    };

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const apiUrl = getApiUrl('/orders/get_orders');
                const response = await fetch(apiUrl);
                await response.json();
                // ... rest of the code ...
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        };
        fetchOrders();
    }, []);

    return (
        <div className="order-check-container" style={{ textAlign: 'center' }}>
            <form onSubmit={query} className="order-form">
                <label htmlFor="orderName">請輸入會員代號：
                （LINE社群用戶請輸入社群暱稱，或者個人LINE名稱；輸入須完全一致，如查無資料請洽詢官方帳號）</label>
                <input
                    type="text"
                    id="orderName"
                    name="orderName"
                    value={orderName}
                    onChange={(e) => setOrderName(e.target.value)}
                    className="order-input"
                />
                <input
                    type="submit"
                    value="查詢"
                    className="submit-button"
                />
            </form>
            {loading && (
                <div>
                    <div className="loader"></div>
                    <div className="loader-text">請稍等</div>
                </div>
            )}
            <div id="result" className="result-container">
                {result.length === 0 ? (
                    <p>未找到相關數據</p>
                ) : (
                    <table className="result-table" style={{ width: '80%', border: '1px solid #ddd', borderCollapse: 'collapse', margin: '0 auto' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>暱稱</th>
                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>品名</th>
                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>商品數量</th>
                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>單品金額</th>
                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>目前二補金額<br />(依出貨通知為準)</th>
                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>已匯款金額</th>
                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>商品狀態</th>
                            </tr>
                        </thead>
                        <tbody>
                            {result.map((row, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.暱稱}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.品名}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.商品數量}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.單品金額}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.應補金額}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.已匯款金額}</td>
                                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.商品狀態}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            <div id="explanation" className="explanation-container">
            	<p>(1) 訂單狀態說明：</p>
            	<p style={{ textIndent: '2em' }}>◎1.訂購中/待發貨：商品正在採買或者已經買好，若想確認此部分狀況，請直接私訊官方帳號。</p>
            	<p style={{ textIndent: '2em' }}>◎2.官方陸續發貨/理貨中：線上購買的商品，官方陸續出貨。實體店購買的商品，正由小幫手打包理貨。</p>
            	<p style={{ textIndent: '2em' }}>◎3.分批空運中：正在分批處理寄送或者正在空運。</p>
            	<p style={{ textIndent: '2em' }}>◎4.抵台理貨中：台灣出貨小幫手已經收到，整理中，請靜待通知唷。</p>
            	<p style={{ textIndent: '2em' }}>◎5.出貨完畢：已寄出給您喔。出貨完畢的紀錄會消除，以防資料累積過多喔。</p>
            	<p>(2) 本查詢系統為自行設計供LINE社群內群友使用，請遵守資料保護勿竊取保存他人資料。該系統也受到智慧財產權保護。</p>
            	<p>有任何問題建議或者許願，歡迎私訊官方帳號，希望讓您開心又安心地帶回寶寶～</p>
            </div>
        </div>
    );
}

export default OrderCheck; 